import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@trashlab/sitesapp/src/routes/__root';
import { HeroSection } from '@trashlab/sitesapp/src/organizations/best-deal/template/components/shared/hero-section';
import { CtaSection } from '@trashlab/sitesapp/src/organizations/best-deal/template/components/shared/cta-section';
import { useTenantContext } from '@trashlab/sitesapp/src/organizations/best-deal/contexts/use-tenant-context';
import { WhoWeAre } from '@trashlab/sitesapp/src/organizations/best-deal/template/components/about/who-we-are';
import { BestDealAbout } from '@trashlab/sitesapp/src/organizations/best-deal/template/components/about/best-deal-about';
import UniqueSkillset from '@trashlab/sitesapp/src/organizations/best-deal/template/components/about/unique-skillset';
import { LearnMore } from '@trashlab/sitesapp/src/organizations/best-deal/template/components/about/learn-more';
import { CompanyStats } from '@trashlab/sitesapp/src/organizations/best-deal/template/components/home/company-stats';
import { Testimonials } from '@trashlab/sitesapp/src/organizations/best-deal/template/components/shared/testimonials-section';
import { useVariantValue } from '@trashlab/sitesapp/src/organizations/best-deal/lib/utils/get-variant-value';
import { asAddress } from '@trashlab/api/src/library/server/utils/json-compatibility';

// Best Deal Dumpsters org ID
const BEST_DEAL_ORG_ID = 'd74bb19c-004b-479d-adaa-9e846d25dac7';

const AboutPage = () => {
  const { website } = useTenantContext();
  const orgAddress = asAddress(website?.organization?.address);
  const city = orgAddress?.city ?? 'San Francisco';
  const state = orgAddress?.state ?? 'CA';

  const isBestDeal = website?.organization?.id === BEST_DEAL_ORG_ID;

  const aboutHeroSubtitle = useVariantValue(
    'ABOUT_HERO_SUBTITLE',
    isBestDeal
      ? 'Best Deal Dumpsters is a locally owned company serving Louisville, KY and surrounding areas. We pride ourselves on great prices, quality service, and protecting your driveway.'
      : `${
          website?.organization?.name || 'Our company'
        } is a reputable, locally owned and operated dumpster rental service serving ${city}, ${state}, and the surrounding communities. Learn more about ${
          website?.organization?.name || 'Our company'
        } below.`,
  );

  // Best Deal org gets a simplified about page with contact form
  if (isBestDeal) {
    return (
      <>
        <HeroSection
          title={`About ${website?.organization?.name || 'Best Deal Dumpsters'}`}
          content={aboutHeroSubtitle}
        />
        <BestDealAbout />
        <Testimonials withBackground />
        <CtaSection secondary />
      </>
    );
  }

  return (
    <>
      <HeroSection
        title={`About ${website?.organization?.name || 'our company'}`}
        content={aboutHeroSubtitle}
      />
      <WhoWeAre />
      <UniqueSkillset />
      <LearnMore />
      <CompanyStats />
      <Testimonials withBackground />
      <CtaSection secondary />
    </>
  );
};

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/about',
  component: AboutPage,
});
